import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { AuthService } from './auth.service'
import { AuthModel } from './store/auth-model'
import { Store, select } from '@ngrx/store'
import { user_loaded, initiate_login } from './store/actions/auth-action-types'

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuardService {
  constructor(
    private store: Store<AuthModel>,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const rootPath = route && route.url && route.url.length > 0 && route.url[0].path
    if (rootPath === 'login' || rootPath === 'logout') {
      return of(true)
    }

    return this.store.pipe(
      select(model => model.isAuthenticated),
      switchMap((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return of(isLoggedIn)
        } else {
          // if the ngrx store doesn't think we're authenticated (for example
          // the user refreshed the page killing the ngrx state but not their
          // authentication status), check if there is existing login information
          // in the session store
          return this.authService.getAppUserInfo().pipe(
            tap(user => {
              if (user) {
                this.store.dispatch(user_loaded({ user }))
              }
            }),
            map(user => {
              return !!user
            })
          )
        }
      }),
      map((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return isLoggedIn
        } else {
          this.store.dispatch(initiate_login({ url: state.url }))
          return false
        }
      })
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(childRoute, state)
  }
}
